import React, { Component } from "react";
import PropTypes from "prop-types";
import TopParties from "../analytics/case-level/top-parties";

const styles = {
  topParties: {
    textAlign: "center",
    margin: 16
  }
};

class PetitionsFiled extends Component {
  static propTypes = {
    year: PropTypes.number.isRequired
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { year } = this.props;
    const q = {
      filing_date: `${year}-01-01--${year}-12-31`
    };
    return (
      <React.Fragment>
        <h2>{`${year}: Most Active PTAB Patent Owners`}</h2>
        <TopParties type="po" k={10} query={q} style={styles.topParties} />
      </React.Fragment>
    );
  }
}

export default PetitionsFiled;
